import { compressImage } from "@/lib/compressImage";
import { IMAGE_ACCEPT } from "@/lib/uploadAccept";

/** Trần ảnh của máy chủ (apps/api/src/routes/files.ts). */
export const MAX_IMAGE_BYTES = 5 * 1024 * 1024;

/**
 * Kiểm ảnh TRƯỚC KHI tải lên, và trả về bản đã nén để không nén hai lần.
 *
 * Chốt chặn thật vẫn ở máy chủ và phải giữ nguyên. Kiểm ở đây chỉ để người dùng
 * không phải đợi tải xong 20 MB qua mạng 4G ở xưởng rồi mới nghe từ chối — và
 * để lời từ chối nói đúng luật ("ảnh tối đa 5 MB") thay vì một mã lỗi HTTP.
 *
 * Xét dung lượng trên bản ĐÃ NÉN: một tấm chụp bằng điện thoại 8 MB nén xong
 * còn vài trăm KB, chặn nó ở kích thước gốc là từ chối đúng thứ vừa chụp.
 */
export async function checkImageFile(
  file: File,
): Promise<{ ok: true; file: File } | { ok: false; reason: "type" | "size" }> {
  if (!IMAGE_ACCEPT.split(",").includes(file.type)) return { ok: false, reason: "type" };
  const compressed = await compressImage(file);
  if (compressed.size > MAX_IMAGE_BYTES) return { ok: false, reason: "size" };
  return { ok: true, file: compressed };
}
